import { RuleTypeEnum } from "../../domain/RuleType";
import { RuleTypeLiteral } from "../../domain/RuleValue";
import { EnrichedRuleValueMap } from "../services/ruleEnrichers/RuleEnricher";
import { SerializedWebCategoryRuleValueStoreData, WebCategoryRuleValueStore } from "./ruleValueStores/WebCategoryRuleValueStore";
import { SerializedWebHostnameRuleValueStoreData, WebHostnameRuleValueStore } from "./ruleValueStores/WebHostnameRuleValueStore";
import { SerializedWebUrlRuleValueStoreData, WebUrlRuleValueStore } from "./ruleValueStores/WebUrlRuleValueStore";
import { SerializedYoutubeChannelRuleValueStoreData, YoutubeChannelRuleValueStore } from "./ruleValueStores/YoutubeChannelRuleValueStore";
import { SerializedYoutubeTopicRuleValueStoreData, YoutubeTopicRuleValueStore } from "./ruleValueStores/YoutubeTopicRuleValueStore";
import { SerializedYoutubeVideoRuleValueStoreData, YoutubeVideoRuleValueStore } from "./ruleValueStores/YoutubeVideoRuleValueStore";

export interface RuleValueStore<T extends RuleTypeLiteral> {
    add(enrichedRuleValue: EnrichedRuleValueMap[T]): void;
    serialize(): SerializedRuleValueStore<T>;
    fromSerialized(serialized: SerializedRuleValueStore<T>): void;
}

type RuleValueStoreMapType = {
    [K in RuleTypeLiteral]: new () => RuleValueStore<K>
};

export const RuleValueStoreMap = {
    [RuleTypeEnum.YOUTUBE_TOPIC]: YoutubeTopicRuleValueStore,
    [RuleTypeEnum.YOUTUBE_VIDEO]: YoutubeVideoRuleValueStore,
    [RuleTypeEnum.YOUTUBE_CHANNEL]: YoutubeChannelRuleValueStore,
    [RuleTypeEnum.WEB_CATEGORY]: WebCategoryRuleValueStore,
    [RuleTypeEnum.WEB_HOSTNAME]: WebHostnameRuleValueStore,
    [RuleTypeEnum.WEB_URL]: WebUrlRuleValueStore,
} satisfies RuleValueStoreMapType;

export interface SerializedRuleValueStore<T extends RuleTypeLiteral = RuleTypeLiteral> {
    type: T;
    data: SerializedRuleValueStoreDataMap[T];
}

export type SerializedRuleValueStoreDataMap = {
    [RuleTypeEnum.YOUTUBE_TOPIC]: SerializedYoutubeTopicRuleValueStoreData,
    [RuleTypeEnum.YOUTUBE_VIDEO]: SerializedYoutubeVideoRuleValueStoreData,
    [RuleTypeEnum.YOUTUBE_CHANNEL]: SerializedYoutubeChannelRuleValueStoreData,
    [RuleTypeEnum.WEB_CATEGORY]: SerializedWebCategoryRuleValueStoreData,
    [RuleTypeEnum.WEB_HOSTNAME]: SerializedWebHostnameRuleValueStoreData,
    [RuleTypeEnum.WEB_URL]: SerializedWebUrlRuleValueStoreData,
};